import Link from 'next/link'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SpotCrowdedLabel } from './SpotCrowdedLabel'

type Props = {
  link: string
  title: string[] | string
  address: string
  query?: string
  course?: string[]
  isCoupon: boolean
  state?: number | string | 'NONE' | 'ACQUIRED'
  img?: string
  hasStamp?: boolean
  point?: number
  spotCrowded?: Api.SpotCrowded
}

export const SpotList = ({
  link,
  title,
  address,
  query,
  course,
  isCoupon,
  state,
  img,
  hasStamp,
  point,
  spotCrowded,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Link
      href={{
        pathname: `${link}`,
        query: {
          query: query,
        },
      }}
    >
      <div className="flex items-center border-b border-gray-200 py-3">
        {img && (
          <div className="c-thumbnail_min-wrap">
            <span className="c-thumbnail_min block">
              <img src={img} alt="" />
            </span>
          </div>
        )}
        <div className="ml-2 flex-1">
          <p className="text-sm font-bold">{title}</p>
          <p className="text-xsss">{address}</p>
          <div className="mt-1 flex items-center space-x-2">
            {!hasStamp ? (
              <>
                <p className="c-tag text-xs text-sub">{course}</p>
                {isCoupon && (
                  <p className="c-tag c-tag--coupon c_clamp inline-block text-xss">
                    {t('spot_detail.coupon', 'クーポン')}
                  </p>
                )}
              </>
            ) : (
              <>
                <p className="text-xs text-color01">{`${
                  state === 'NONE'
                    ? t('spot_detail.un_acquired', '未獲得')
                    : state === 'ACQUIRED'
                      ? t('spot_detail.acquired', '獲得済み')
                      : '期間外'
                }`}</p>
                {course
                  ? course.map((v, i) => {
                      return (
                        <p className="c-tag c_clamp inline-block text-xss text-sub" key={v}>
                          {v}
                        </p>
                      )
                    })
                  : ''}
                {isCoupon && (
                  <p className="c-tag c-tag--coupon c_clamp inline-block text-xss">
                    {t('spot_detail.coupon', 'クーポン')}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
        {point && (
          <div className="text-[20px] font-bold">
            {point}
            <span className="text-[16px]">pt</span>
          </div>
        )}
        {!point && spotCrowded && (
          <div className="flex h-full self-start py-2">
            <SpotCrowdedLabel spotCrowded={spotCrowded} />
          </div>
        )}
      </div>
    </Link>
  )
}
